import { createSelector } from 'reselect';

import { getCatalog } from './getCatalog';

export const getSelectedCategoryId = createSelector(
  getCatalog,
  catalog => catalog.selectedCategoryId,
);
